import { validateNumeric } from '@/EventLogic/util';

export default function (component, config) {
  if (!component.fieldset || !config.sourceFieldsets[component.fieldset]) {
    return {
      fieldset: 'Please select a field.'
    };
  }

  if (!config.sourceFieldsets[component.fieldset].numeric) {
    return validateMultipleChoice(component);
  }

  return validateNumeric(component);
}

function validateMultipleChoice(component) {
  if (component.compliantChoices.length < 1) {
    return {
      compliantChoices: "Please select at least one valid choice."
    };
  }

  return {};
}
